import { supportNav, supportBanner, supportBannerMobile } from 'constants/index';
import Banner from 'components/banner';
interface IProps {
  pageKey: string;
}
export default function IndexView(props: IProps) {
  const { pageKey } = props;
  return <Banner pageKey={pageKey} bgImage={supportBanner} bgImageMobile={supportBannerMobile} menu={supportNav} title="支持中心" />;
}
